import { createState } from 'shared'

import { UserIcon, Input, SentIcon } from 'components/UI/atoms'
// import { dAppFeaturesState, handleSelectFeature } from 'state'

// TODO: Temporaly state until implement chat
const messageState = createState('')

export const updateMessage = (value: string) => {
	messageState.updateState(() => value)
}

// TODO: Move to a new component
const Tags = () => (
	<div class='flex flex-wrap gap-2'>
		{/* {dAppFeaturesState.value.map(
			feature =>
				feature.isSelected && (
					<RemovableTag
						key={feature.id}
						onClose={() => handleSelectFeature(feature.id)}
					>
						{feature.name}
					</RemovableTag>
				)
		)} */}
	</div>
)

// TODO: First implementation. Should be refactored to create more components
const DAppChat = () => (
	<div class='flex h-full flex-col rounded border border-dividers bg-black p-4'>
		<Tags />

		<div class='mb-4 ml-10 mt-10'>
			<p class='font-inter text-sm font-light text-customWhite'>
				Create a blockchain-based inventory management system for an e-commerce
				platform where the based CIDL is e-commerce. The difference is that in
				my idea...
			</p>
		</div>

		<div class='mb-4 mt-10 flex'>
			<div class='flex h-7 w-7 items-center justify-center rounded-full bg-brightBackground'>
				<UserIcon className='h-3.5 w-3.5' />
			</div>

			<div class='ml-2.5 flex-1'>
				<p class='font-inter text-sm font-medium text-customWhite'>Tú</p>

				<p class='font-inter text-sm font-light text-customWhite'>
					Create a blockchain-based inventory management system for an
					e-commerce platform where the based CIDL is e-commerce. The difference
					is that in my idea..…. An NFT marketplace where users can mint,
					transfer, and burn their NFT. Compress your data on-ledger to reduce
					gas fee.
				</p>
			</div>
		</div>

		<div class='mt-auto'>
			<Input
				endAdornment={<SentIcon />}
				id='chat-input'
				onInput={updateMessage}
				placeholder='Send a message to Código AI'
				type='text'
				value={messageState.state}
			/>
		</div>
	</div>
)

export { DAppChat }
